import React from 'react';
export default function ActionHeader({ children, text }) { return /*#__PURE__*/ React.createElement("div", { className: "action-header" }, /*#__PURE__*/ React.createElement("h3", null, text), /*#__PURE__*/ React.createElement("div", { className: "action-header__actions" }, children)); }
